/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:19:15
 */
export default {
  lang: "英语",
  landing: {
    name1: "Abrir Carlcare",
    name2: "Hacer una reserva",
    name3: "Con Carlcare, puede consultar su orden en cualquier momento.",
    name4: "",
    name5: "Deslice hacia la derecha",
    name6: "Verificación completa",
        name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02130204983.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
  },
  order: {
    name1: "Elegir modelo de dispositivo",
    name2: "Descripción de la falla:",
    name3: "Toque para seleccionar la tienda de servicios",
    name4: "Tienda de servicio:",
    name5: "Hora de reserva:",
    name6: "¡Describa el problema de su dispositivo en detalle!",
    name7: "Toque para seleccionar la hora de llegada",
    name8: "Ingrese sus datos de contacto correctos para que podamos comunicarnos con usted",
    name9: "El horario de reserva disponible es el siguiente",
    name10: "Por favor, ingresa tu número de teléfono",
    name11: "Precio",
    name12: "Información personal:",
    name13: "Ingresa tu nombre",
    name14: "Enviar",
    name15: "Cancelar",
    name16: "ACEPTAR",
  },
  shops: {
    name1: "Basado en las marcas que le gustan, ¡estas tiendas le podrían interesar!",
    name2: "¡Próximamente en más tiendas minoristas! ¡Quédese al tanto de nuestras novedades!",
  },
  price: {
    name1: "Marca",
    name2: "Modelo",
    name3: "ARTÍCULO",
    name4: "Precio",
    name5: "Recordatorio amistoso:",
    name6: "Estos precios son solo a modo de referencia, y el precio real queda sujeto a la condición de su dispositivo.",
    name7: "Si no hay un símbolo especial, la unidad de precio corresponde a la unidad de moneda local.",
    name8: "¡Lo sentimos! No hay información de precios disponible en la región actual.",
    name11:"Coste laboral",
    name12:"Precio total",
    name13: "5. Si el coste de mano de obra es \"/\", significa que hay que consultarlo con la tienda.",
    item_main_board: "Placa principal",
    item_screen_frame: "Pantalla (Marco)",
    item_screen_screen_frame: "Pantalla secundaria (Marco)",
    item_touch_screen: "Pantalla táctil",
    item_camera: "\"Cámara\"",
    item_fixed_focus_camera: "Cámara de enfoque fijo",
    item_auto_focus_camera: "Cámara de enfoque automático",
    item_screen: "Pantalla",
    item_secondary_screen: "Pantalla secundaria",
    item_fingerprint_module: "Módulo de huella dactilar",
    item_speaker: "Altavoz",
    item_receiver: "Receptor",
    item_small_board: "Tablero pequeño",
    item_battery_cover: "Cubierta de la batería",
    item_battery: "Batería",
    item_charger: "Cargador",
    item_usb_cable: "Cable USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "No hay datos",
    name2: "Proveedor de servicio:",
    name3: "Marca del servicio:",
    name4: "Teléfono:",
    name5: "Cantidad del pedido:",
    name6: "Calificación del servicio",
    name7: "Entorno del servicio:",
    name8: "Actitud del servicio:",
    name9: "Eficiencia del servicio:",
    name10: "Calidad del servicio:",
    name11: "Evaluación del Cliente",
    name12:"para",
    name13:"Desactivado",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Abrir Carlcare",
    name1: "Tome una captura de pantalla de la información de la reserva y guárdela como comprobante para acceder al servicio de prioridad.",
    name2: "Enviado satisfactoriamente",
    name3: "1. Elimine datos",
    name4: "Haga una copia de seguridad de la información privada importante en su teléfono con anticipación",
    name5: "2. Desactive la contraseña de encendido",
    name6: "Antes de dirigirse al local de servicio, por favor:",
    name7: "Tienda de servicio:",
    name8: "Hora de reserva:",
    name9: "Descripción de la falla:",
    name10: "Modelo del dispositivo:",
    name11: "Número de orden:",
    name12: "Información del pedido",
  },
  title: {
    
    name1: "Compatible con los siguientes países:",
    name2: "Elija modelo",
    name3: "Reserva",
    name4: "Detalles de la tienda de servicio",
    name5: "Seleccionar tienda de servicios",
  },
  error: {
    
    name1: "No hay datos. Corrobore la información de su reparación",
    name2: "¿Necesita más ayuda? Por favor contáctenos.",
    name3: "Lo sentimos, no hay centros de Carlcare en la región actual.",
    name4: "Primero seleccione un centro de servicio",
    name5: "Error",
    name6: "Primero seleccione el modelo del dispositivo",
    name7: "Detalles",
    name8: "Describa sus necesidades en detalle",
    name9: "",
  },
  add1:{
    "name0": "es-rUS",
    "name1": "Su pedido ha sido confirmado. Esperamos su llegada.",
    "name2": "Seleccionar ciudad",
    "name3": "Por favor, introduzca un número de teléfono de %1$s dígitos.",
    "name4": "Horas de Día Laborable",
    "name5": "Lunes",
    "name6": "Martes",
    "name7": "Miércoles",
    "name8": "Jueves",
    "name9": "Viernes",
    "name10": "Sábado",
    "name11": "Domingo",
    "name12": "Introduzca el país y busque"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "Otros",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Pulse para redirigir",
    name3:"Abra la aplicación Carlcare para calificar el pedido",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Seleccione el servicio",
    name7:"Limpieza gratuita",
    name8:"Actualización de software",
  },
  cancelorder:{
    "cancelReason0": "Información incorrecta",
    "cancelReason1": "No puede llegar a tiempo",
    "cancelReason2": "Pedido duplicado/no es mi pedido",
    "cancelReason3": "No vuelve a fallar",
    "cancelReason4": "Solo para probar/consultar/evento/…",
    "cancelReason5": "Precio alto",
    "cancelReason6": "Escasez de material",
    "cancelReason7": "Servicios no diferenciados",
    "cancelReason8": "La tienda está muy lejos",
    "cancelReason9": "La tienda está cerrada",
    "cancelReason10": "Pésima calidad de servicio",
    "cancelReason11": "Cambio/reparación de otras marcas",
    "cancelReason12": "No puedo encontrar la tienda",
    "cancelReason13": "Otro",
    "cancelOrder": "Cancelar pedido",
    "reason_dialog_title": "Indíquenos el motivo de la cancelación",
    "Cancel": "Cancelar",
    "OK": "Aceptar",
    "name1": "Ingresa el código de verificación",
    "name2": "Código de verificación no válida",
    "repair_reservation_detail_canceled": "¡Este pedido ha sido cancelado!",
    "purchase_cancel_dialog_content": "¿Confirma la cancelación del pedido?",
    "yes": "Pantalla",
    "no": "No mostrar"
}
};
